import React from 'react';
import { Section, FadeIn, StaggerContainer, StaggerItem } from './ui';
import { Moon, Salad, Activity, Sparkles } from 'lucide-react';
export const SolutionSection = () => {
  const pillars = [{
    icon: <Moon className="w-8 h-8 text-sage" data-id="element-305" />,
    title: 'Sincronización del Sueño',
    desc: 'Alinea los ritmos circadianos con la biología hormonal actual.'
  }, {
    icon: <Salad className="w-8 h-8 text-sage" data-id="element-306" />,
    title: 'Nutrición Antiinflamatoria',
    desc: 'Alimenta las células con lo que necesitan en esta etapa específica.'
  }, {
    icon: <Activity className="w-8 h-8 text-sage" data-id="element-307" />,
    title: 'Movimiento Inteligente',
    desc: 'Activa la energía sin generar estrés hormonal adicional.'
  }];
  return <>
      {/* Mechanism / Aha Moment */}
      <Section bg="bg-cream" data-id="element-308">
        <FadeIn data-id="element-309">
          <div className="max-w-4xl mx-auto" data-id="element-310">
            <div className="text-center mb-12" data-id="element-311">
              <span className="inline-flex items-center gap-2 text-gold font-bold tracking-wider uppercase text-sm mb-4" data-id="element-312">
                <Sparkles className="w-4 h-4" data-id="element-313" />
                El Mecanismo
              </span>
              <h2 className="text-3xl md:text-5xl font-bold mb-6 leading-tight" data-id="element-314">
                ¿Por qué sigues agotada aunque haces todo bien?
              </h2>
            </div>

            <div className="bg-white p-8 md:p-12 rounded-3xl shadow-sm border border-cream-dark space-y-6 text-lg text-brown-light leading-relaxed" data-id="element-315">
              <p data-id="element-316">
                Durante la menopausia, los niveles de estrógeno y progesterona
                caen de forma abrupta. Esto no solo afecta el estado de ánimo o
                los sofocos.
              </p>
              <p data-id="element-317">
                Afecta directamente cómo tu cuerpo produce y usa la energía
                celular.
              </p>
              <p className="text-brown font-medium bg-cream-light p-6 rounded-2xl border-l-4 border-gold" data-id="element-318">
                El resultado es lo que los especialistas llaman{' '}
                <span className="italic" data-id="element-319">fatiga hormonal profunda</span> — un
                estado donde el cuerpo está desincronizado con sus propios
                ritmos naturales.
              </p>
              <p data-id="element-320">
                La mayoría de los enfoques tratan los síntomas por separado. El
                sueño por un lado. La alimentación por otro. El ejercicio por
                otro.
              </p>
              <p className="text-brown font-medium" data-id="element-321">
                Pero ninguno los sincroniza entre sí — ni los alinea con los
                ritmos hormonales específicos de una mujer de 50+.
              </p>
            </div>
          </div>
        </FadeIn>
      </Section>

      {/* The Solution: Method */}
      <Section bg="bg-sage-light/30" data-id="element-322">
        <FadeIn data-id="element-323">
          <div className="max-w-4xl mx-auto text-center mb-16" data-id="element-324">
            <span className="text-sage font-bold tracking-wider uppercase text-sm mb-4 block" data-id="element-325">
              La Solución
            </span>
            <h2 className="text-3xl md:text-5xl font-bold mb-8 leading-tight" data-id="element-326">
              El Método de{' '}
              <span className="text-gold italic font-normal" data-id="element-327">
                Micro-Sincronización Hormonal
              </span>
            </h2>
            <p className="text-lg md:text-xl text-brown-light leading-relaxed" data-id="element-328">
              En lugar de atacar síntomas aislados, trabaja sobre tres palancas
              simultáneas que se refuerzan entre sí.
            </p>
          </div>
        </FadeIn>

        <StaggerContainer className="grid md:grid-cols-3 gap-6 md:gap-8 max-w-5xl mx-auto" data-id="element-329">
          {pillars.map((pillar, i) => <StaggerItem key={i} data-id="element-330">
              <div className="bg-white p-8 rounded-3xl h-full border border-cream-dark shadow-sm hover:shadow-md transition-shadow text-center" data-id="element-331">
                <div className="w-16 h-16 bg-sage-light rounded-full flex items-center justify-center mb-6 mx-auto" data-id="element-332">
                  {pillar.icon}
                </div>
                <h3 className="text-xl font-bold mb-3 text-brown" data-id="element-333">
                  {pillar.title}
                </h3>
                <p className="text-brown-light leading-relaxed" data-id="element-334">
                  {pillar.desc}
                </p>
              </div>
            </StaggerItem>)}
        </StaggerContainer>

        <FadeIn delay={0.3} data-id="element-335">
          <div className="max-w-2xl mx-auto text-center mt-16" data-id="element-336">
            <p className="text-xl md:text-2xl text-brown font-medium leading-relaxed" data-id="element-337">
              No es más esfuerzo.
            </p>
            <p className="text-xl md:text-2xl text-gold font-bold italic mt-3" data-id="element-338">
              Es el esfuerzo correcto — en el momento correcto — para el cuerpo
              correcto.
            </p>
          </div>
        </FadeIn>
      </Section>
    </>;
};